import React from 'react';
import { useOutbox } from '../hooks/useOutbox';
import { MARK } from '../constants';

/**
 * Faixa de estado: conexão e fila de envio.
 *
 * Substitui o aviso que só falava de conexão. O que o técnico precisa saber em
 * campo é uma pergunta só — "o que eu lancei está seguro?" — e a resposta
 * depende dos dois: se há sinal e se a fila esvaziou.
 *
 * Fica invisível quando está tudo online e a fila vazia, que é o caso normal.
 */
const SyncBanner = () => {
  const { pending, blocked, syncing, online, needsLogin, sync } = useOutbox();

  const naFila = pending.length;
  const recusados = blocked.length;

  if (online && naFila === 0 && !needsLogin) return null;

  const plural = (n, um, muitos) => (n === 1 ? um : muitos);

  return (
    <div className="bg-slate-800 text-white text-xs px-4 py-1.5 flex items-center justify-center gap-2 flex-wrap">
      {!online && (
        <span>
          <span aria-hidden="true">{MARK.WARN}</span>{' '}
          Sem conexão — mostrando os dados salvos no aparelho.
        </span>
      )}

      {naFila > 0 && (
        <span>
          <span aria-hidden="true">{MARK.PENDING}</span>{' '}
          <strong>{naFila}</strong>{' '}
          {plural(naFila, 'lançamento aguardando', 'lançamentos aguardando')} envio
          {online && !syncing && '.'}
          {syncing && ' — enviando…'}
        </span>
      )}

      {needsLogin && (
        <span>
          <span aria-hidden="true">{MARK.WARN}</span>{' '}
          Sua sessão expirou. <strong>Entre novamente</strong> para os lançamentos subirem —
          eles estão guardados.
        </span>
      )}

      {recusados > 0 && (
        <span title={blocked.map(b => `${b.label}: ${b.lastError}`).join('\n')}>
          <span aria-hidden="true">{MARK.BAD}</span>{' '}
          <strong>{recusados}</strong>{' '}
          {plural(recusados, 'foi recusado', 'foram recusados')} pelo servidor.
        </span>
      )}

      {online && naFila > 0 && !syncing && (
        <button
          onClick={sync}
          className="underline underline-offset-2 hover:text-slate-300"
        >
          tentar agora
        </button>
      )}
    </div>
  );
};

export default SyncBanner;
